import React from "react";
import { H1, H2, H3 } from "../../../styles/Typography";
import { PrimaryButton } from "../../elements/Buttons";
import { navigate } from "@reach/router";
import TiraiKiri from "../../../images/coming_soon/Tirai_Kiri.svg";
import TiraiKanan from "../../../images/coming_soon/Tirai_Kanan.svg";
import Upper from "../../../images/coming_soon/Upper.svg";
import TiraiKiriMobile from "../../../images/coming_soon/Tirai_Kiri_Mobile.svg";
import TiraiKananMobile from "../../../images/coming_soon/Tirai_Kanan_Mobile.svg";
import TiraiKiriTablet from "../../../images/coming_soon/Tirai_Kiri_Tablet.svg";
import TiraiKananTablet from "../../../images/coming_soon/Tirai_Kanan_Tablet.svg";
import UpperTablet from "../../../images/coming_soon/Upper_Tablet.svg";
import { ComingSoonWrapper } from "./style";

const Panggung = ({ title, buttonText, redirectLink }) => {
  const redirect = (event) => {
    navigate(redirectLink);
  };

  return (
    <div className="md:min-h-screen lg:min-h-full xl:min-h-screen ">
      <ComingSoonWrapper>
        <div className="flex flex-col gap-2 items-center">
          <H1
            style={{ color: "#FFFF", textAlign: "center" }}
            className="lg:flex hidden"
          >
            {title}
          </H1>
          <H2
            style={{ color: "#FFFF", textAlign: "center", width: "360px" }}
            className="md:flex hidden lg:hidden"
          >
            {title}
          </H2>
          <div style={{ maxWidth: "250px" }}>
            <H3
              style={{ color: "#FFFF", textAlign: "center" }}
              className="md:hidden flex"
            >
              {title}
            </H3>
          </div>

          {buttonText ? (
            <>
              <PrimaryButton onClick={() => redirect()}>
                {buttonText}
              </PrimaryButton>
            </>
          ) : null}
        </div>
        <>
          <img
            src={TiraiKiri}
            alt="Tirai kiri"
            className="absolute lg:hidden xl:flex hidden -top-12 left-0"
          />
          <img
            src={TiraiKanan}
            alt="Tirai kanan"
            className="absolute -top-12 lg:hidden xl:flex hidden right-0"
          />
          <img
            src={Upper}
            alt="Upper"
            className="absolute lg:flex hidden top-0 z-20"
          />
        </>

        <>
          <img
            src={TiraiKiriMobile}
            alt="Tirai kiri"
            className="absolute md:hidden flex -top-6 left-0"
          />
          <img
            src={TiraiKananMobile}
            alt="Tirai kanan"
            className="absolute md:hidden flex -top-6 right-0"
          />
          <img
            src={UpperTablet}
            alt="Upper"
            className="absolute md:hidden flex top-0"
          />
        </>

        <img
          src={TiraiKiriTablet}
          alt="Tirai kiri"
          className="absolute md:flex hidden lg:flex lg:-top-14 xl:top-0 xl:hidden left-0"
        />
        <img
          src={TiraiKananTablet}
          alt="Tirai kanan"
          className="absolute md:flex hidden lg:flex lg:-top-14 xl:top-0 xl:hidden right-0"
        />
        <img
          src={UpperTablet}
          alt="Upper"
          className="absolute md:flex hidden lg:hidden top-0"
        />
      </ComingSoonWrapper>
    </div>
  );
};

export default Panggung;
